import type { MessagingCreateChatRoom201LastMessageSenderBasicInfo } from './messagingCreateChatRoom201LastMessageSenderBasicInfo';
import type { MessagingCreateChatRoom201LastMessageSenderSocial } from './messagingCreateChatRoom201LastMessageSenderSocial';

/**
 * 발신자 정보
 */
export type MessagingCreateChatRoom201LastMessageSender = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingCreateChatRoom201LastMessageSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingCreateChatRoom201LastMessageSenderSocial;
};
